/*eslint-disable*/
import axios from 'axios';
import {baseApiUrl} from "../../../environmentConfig.js";
const state = {
  accessToken: "",
}
const mutations = {
  storeToken (state, accessToken) {
    state.accessToken = accessToken
  },
}
const actions = {
  async login({dispatch, commit}, userData) {
    let loginUrl = baseApiUrl+"login"
    // let data = {
    //   data: userData
    // }
    let config = {
      responseType: 'json'
    }
    return new Promise(function(resolve, reject) {
      axios.post(loginUrl, userData, config).then(result=>{
        // this should return token + user details if needed.
        // by default it will only return accessToken
        if (result.data) {
          console.log("has result");
          console.log(result.data);
          resolve(result.data)
        }
        else {
          console.log("has no result");
          console.log(result.data);
          reject("Invalid Login")
        }
      })
    });
  }
}
const getters = {

}
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
